import { CAT_PATENT_RESEARCH } from 'App/utils/Collections';

export default {
  category: CAT_PATENT_RESEARCH,
  filters: [],
  searchBarProp: 'name',
};
